"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateOpportunityRfpCoverDetailDto = exports.FileUploadConfigDto = exports.RemarksConfigDto = exports.CoversConfigDto = exports.CoverQuestionDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class CoverQuestionDto {
}
exports.CoverQuestionDto = CoverQuestionDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Question and its answer",
        example: {
            question1: "Answer for Accidental Death Benefit",
        },
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Cover questions must not be empty" }),
    (0, class_validator_1.IsString)({ each: true, message: "Each question must be a string" }),
    tslib_1.__metadata("design:type", String)
], CoverQuestionDto.prototype, "question1", void 0);
class CoversConfigDto {
}
exports.CoversConfigDto = CoversConfigDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Key-value pair of Cover ID and Questions",
        example: {
            "165": {
                question1: "Answer for Accidental Death Benefit",
            },
            "166": {
                question1: "Answer for Maturity Benefit",
            },
            "167": {
                question1: "Answer for Critical Illness Cover",
            },
        },
    }),
    (0, class_validator_1.IsObject)({
        message: "CoversConfig must be an object with cover IDs as keys",
    }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => CoverQuestionDto),
    tslib_1.__metadata("design:type", typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object)
], CoversConfigDto.prototype, "coversConfig", void 0);
class RemarksConfigDto {
}
exports.RemarksConfigDto = RemarksConfigDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Remarks for the submission",
        example: "Sample remarks for the submission",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Remarks must be a string" }),
    tslib_1.__metadata("design:type", String)
], RemarksConfigDto.prototype, "remarks", void 0);
class FileUploadConfigDto {
}
exports.FileUploadConfigDto = FileUploadConfigDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document ID",
        example: 292,
    }),
    (0, class_validator_1.IsInt)({ message: "Document ID must be an integer" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document ID is required" }),
    tslib_1.__metadata("design:type", Number)
], FileUploadConfigDto.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document ID",
        example: 292,
    }),
    (0, class_validator_1.IsInt)({ message: "Document LID must be an integer" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document ID is required" }),
    tslib_1.__metadata("design:type", Number)
], FileUploadConfigDto.prototype, "documentTypeLid", void 0);
class CreateOpportunityRfpCoverDetailDto {
}
exports.CreateOpportunityRfpCoverDetailDto = CreateOpportunityRfpCoverDetailDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Opportunity Activity ID",
        example: 573,
    }),
    (0, class_validator_1.IsInt)({ message: "Opportunity Activity ID must be an integer" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Opportunity Activity ID is required" }),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityRfpCoverDetailDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Opportunity Activity statusLid",
        example: 573,
    }),
    (0, class_validator_1.IsInt)({ message: "Opportunity statusLid must be an integer" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Opportunity statusLid is required" }),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityRfpCoverDetailDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Configuration for covers",
        example: {
            "165": {
                question1: "Answer for Accidental Death Benefit",
            },
            "166": {
                question1: "Answer for Maturity Benefit",
            },
            "167": {
                question1: "Answer for Critical Illness Cover",
            },
        },
    }),
    (0, class_validator_1.IsObject)({
        message: "CoversConfig must be an object with cover IDs as keys",
    }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object)
], CreateOpportunityRfpCoverDetailDto.prototype, "coversConfig", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Configuration for remarks",
        type: RemarksConfigDto,
    }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => RemarksConfigDto),
    tslib_1.__metadata("design:type", RemarksConfigDto)
], CreateOpportunityRfpCoverDetailDto.prototype, "remarksSection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Configuration for file uploads",
        type: [FileUploadConfigDto],
    }),
    (0, class_validator_1.IsArray)({ message: "FileUploadConfig must be an array" }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => FileUploadConfigDto),
    tslib_1.__metadata("design:type", Array)
], CreateOpportunityRfpCoverDetailDto.prototype, "documents", void 0);
